import './App.css';
import {Switch,Route,Link, Router} from 'react-router-dom';
import {Layout,Typography,Space} from 'antd';
import {Navbar,Exchanges,Homepage,Cryptocurrencies,News,CryptoDetails} from './components';
function App() {
  return (
    <div className="app">
      <div className="navbar">
        <Navbar/>
      </div>
      <div className="main">
        <Layout>
          <div className="routes">
            <Switch>
              <Route exact path="/">
                <Homepage/>
              </Route>
              <Route exact path="/exchanges">
                <Exchanges/>
              </Route>
              <Route exact path="/cryptocurrencies">
                <Cryptocurrencies/>
              </Route>
              <Route exact path="/crypto/:coinId">
                <CryptoDetails/>
              </Route>
              <Route exact path="/news">
                <News/>
              </Route>
            </Switch>
          </div>
        </Layout>
        <div className="footer">
         <Typography.Title level={5} style={{color:'white',textAlign:'center'}}>
           Cyptoverse <br/>
           All rights reserved
         </Typography.Title>
         <Space>
            <Link to="/">Homepage</Link>
            <Link to="/exchanges">Exchange</Link>
            <Link to="/news">News</Link>
          </Space>
        </div>
      </div>
    </div>
  );
}

export default App;
